import type { ReactElement } from 'react';
import { IconCheck, IconCopy, IconX } from '@tabler/icons-react';
import { dataEl, type DataElScope } from '@/utils/dataEl';
import { getFontFamily } from '@/theme/typography';
import { POPOVER_ACTION_DATA_NAME, POPOVER_ACCENT, POPOVER_CLOSE_COLOR, POPOVER_CLOSE_LABEL, POPOVER_COPY_LABEL, POPOVER_DRAG_CURSOR, POPOVER_HEADER_BORDER_BOTTOM, POPOVER_TEXT_TRANSFORM_UPPERCASE, TABLE_STYLE_VALUE, } from './Cmarkdowntable.constants';
import { CmarkdowntablePopoverActionButton } from './CmarkdowntablePopoverActionButton';
import type { TablePopoverPointerHandler } from './Cmarkdowntable.types';
interface CmarkdowntablePopoverHeaderProps {
    dataElScope: DataElScope;
    idValue: string;
    didCopy: boolean;
    onCopyEntries: () => void;
    onClose: () => void;
    onHeaderPointerDown: TablePopoverPointerHandler;
    onHeaderPointerMove: TablePopoverPointerHandler;
    onHeaderPointerEnd: TablePopoverPointerHandler;
}
export function CmarkdowntablePopoverHeader({ dataElScope, idValue, didCopy, onCopyEntries, onClose, onHeaderPointerDown, onHeaderPointerMove, onHeaderPointerEnd, }: CmarkdowntablePopoverHeaderProps): ReactElement {
    const copyColor = didCopy ? POPOVER_ACCENT : POPOVER_CLOSE_COLOR.Idle;
    const copyHoverColor = didCopy ? POPOVER_ACCENT : POPOVER_CLOSE_COLOR.Hover;
    return (<div data-el={dataEl(dataElScope, 'PopoverHeader/Root')} onPointerDown={onHeaderPointerDown} onPointerMove={onHeaderPointerMove} onPointerUp={onHeaderPointerEnd} onPointerCancel={onHeaderPointerEnd} style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 8,
            padding: '11px 14px',
            borderBottom: POPOVER_HEADER_BORDER_BOTTOM,
            flexShrink: 0,
            cursor: POPOVER_DRAG_CURSOR,
            userSelect: TABLE_STYLE_VALUE.UserSelectNone,
            touchAction: TABLE_STYLE_VALUE.TouchActionNone,
        }}>
        <span style={{
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            fontFamily: getFontFamily(),
            fontSize: 10,
            letterSpacing: '0.18em',
            textTransform: POPOVER_TEXT_TRANSFORM_UPPERCASE,
            fontWeight: 700,
            minWidth: 0,
        }}>
          <span aria-hidden style={{
            width: 5,
            height: 5,
            borderRadius: '50%',
            backgroundColor: POPOVER_ACCENT,
            boxShadow: `0 0 8px ${POPOVER_ACCENT}`,
            flexShrink: 0,
        }}/>
          <span style={{ color: POPOVER_ACCENT }}>
            Row
          </span>
          <span style={{ color: 'rgba(255,255,255,0.25)' }}>
            /
          </span>
          <span style={{
            color: 'rgba(255,255,255,0.8)',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
        }}>
            {idValue}
          </span>
        </span>
        <div style={{ display: 'flex', alignItems: 'center', gap: 4, flexShrink: 0 }}>
          <CmarkdowntablePopoverActionButton dataName={POPOVER_ACTION_DATA_NAME.Copy} onClick={onCopyEntries} ariaLabel={didCopy ? POPOVER_COPY_LABEL.Done : POPOVER_COPY_LABEL.Idle} idleColor={copyColor} hoverColor={copyHoverColor}>
            {didCopy ? <IconCheck size={13} stroke={2}/> : <IconCopy size={13} stroke={2}/>}
          </CmarkdowntablePopoverActionButton>
          <CmarkdowntablePopoverActionButton dataName={POPOVER_ACTION_DATA_NAME.Close} onClick={onClose} ariaLabel={POPOVER_CLOSE_LABEL} idleColor={POPOVER_CLOSE_COLOR.Idle} hoverColor={POPOVER_CLOSE_COLOR.Hover}>
            <IconX size={12} stroke={2}/>
          </CmarkdowntablePopoverActionButton>
        </div>
    </div>);
}
